import React from 'react';
import PropTypes from 'prop-types';
import postal from 'postal';

export default class Embed extends React.Component {
  static propTypes = {
    wire: PropTypes.shape({
      id: PropTypes.number.isRequired,
      slug: PropTypes.string.isRequired,
      embedWireUrl: PropTypes.string.isRequired,
      linkWireUrl: PropTypes.string.isRequired,
    }).isRequired,
  }

  presentEmbedWireModal(e) {
    e && e.preventDefault && e.preventDefault();
    postal.publish({
      channel: 'wire.view.commands',
      topic: 'present-embed-wire-modal',
      data: {
        embedWireUrl: this.props.wire.embedWireUrl,
        linkWireUrl: this.props.wire.linkWireUrl,
      },
    });
  }

  render() {
    return (
      <a href="#" onClick={e => this.presentEmbedWireModal(e)} title="Share this wire directly or by embedding it in your site">
        <span
          data-statisticable-event="click"
          data-statisticable-type="wire"
          data-statisticable-event-type="copied_share"
          data-statisticable-id={this.props.wire.id}
          className="icon-lw icon-lw-embed"
        />
      </a>
    );
  }
}
